<script>
import { ref } from "vue";

export default {
    data() {
        return {
            width: window.innerWidth,
            height: window.innerHeight,
            activecolor: "color: #3675aa",
            dataOption: "HadCRUT5", // 默认选项
            iframeHeight: 710
        }
    },
    mounted() {
        this.updateIframeHeight();
        window.addEventListener('resize', this.updateIframeHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateIframeHeight);
    },
    methods: {
        selectDataSource() {
            console.log('Selected data source:', this.dataOption);
            // 向iframe发送消息，通知切换数据源
            const iframe = document.querySelector('iframe');
            if (iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage({
                    type: 'switchDataSource',
                    dataSource: this.dataOption
                }, '*');
            }
        },
        Mouseover() {
            this.activecolor = "color:#78aad1";
        },
        Mouseleave() {
            this.activecolor = "color: #3675aa";
        },
        updateIframeHeight() {
            const width = window.innerWidth;
            if (width > 700) {
                this.iframeHeight = 710;
            } else {
                this.iframeHeight = 500;
            }
        },
    },
}
</script>

<template>
    <div id="main">
        <div id="title">
            <div style="font-size:19px;font-weight: bold;font-family: Segoe UI;">
                <p>Attributed human-induced shifts in annual temperature normals between 1961-1990 and 1991-2020</p>
            </div>
        </div>

        <el-form style="width: 100%;" label-position="top" ref="form" :inline="true">
            <div style="display: flex; width: 100%; flex-wrap: wrap; ">
                <el-form-item label="Observation dataset:" class="is-fill">
                    <el-select @change="selectDataSource" style="width: 100%; display: inline-block; "
                        class="custom-select" v-model="dataOption">
                        <el-option label="HadCRUT5" value="HadCRUT5"></el-option>
                        <el-option label="CMSTv2" value="CMST"></el-option>
                        <el-option label="GISTEMPv4" value="GIS"></el-option>
                        <el-option label="NOAAGlobalTemp v6" value="NOAA"></el-option>
                    </el-select>
                </el-form-item>
            </div>
        </el-form>

        <iframe
            :style="{ width: '100%', height: iframeHeight + 'px', display: 'flex', alignItems: 'center', justifyContent: 'center' }"
            src='/atlas_HadCRUT5.html'>
        </iframe>

        <div style="margin:0 auto;text-align:justify;border-top:solid 1px black;padding-top:6dvb">
            <div style="font-weight: bold;">Method:</div>
            <p class="para-1" style="text-align: left;">Local warming is assessed by comparing observed temperature
                changes with expectations from climate model simulations. A statistical method known as optimal
                fingerprinting is used to detect and attribute human influence at each location. Where human influence
                is detected, the human-induced shifts in annual temperature normals are estimated. Grid cells where
                human influence is not detected are shown as blank.</p>
            <div style="font-weight: bold;">Reference:</div>
            <p class="para-1" style="text-align: left;"><a :style="activecolor" style="text-decoration: none;"
                    @mouseover="Mouseover()" @mouseleave="Mouseleave()">H. Yan, F. Du, F. W. Zwiers, X. Zhang, C. Zhu,
                    L. Yuan, and C. Li*, Quantifying the human contributions to local warming (submitted)
                </a></p>
        </div>
    </div>
</template>

<style scoped>
#main {
    width: 100%;
}

#title {
    width: auto;
    display: flex;
    align-items: center;
    justify-self: center;
}

.para-1 {
    width: 100%;
    margin: auto;
    text-align: justify;
    color: #222121;
    margin-top: 12px;
    padding-left: 20px;
    font-size: 18px;
    margin-bottom: 14px;
}

.selections {
    margin: 20px 0;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
}

.custom-select /deep/ .el-input__inner {
    color: #0c0c0c !important;
    border: 1px solid #0d0d0d;
}

.el-form-item {
    margin-right: 24px;
    background: #edf0f6;
    border-radius: 8px;
    padding: 32px 18px 18px;
    position: relative;
    box-shadow: 0 0 2px #8990a5;
    margin-top: 16px;
}

.el-form-item /deep/ .el-form-item__label {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 8px;
    position: absolute;
    border-radius: 4px;
    border: solid 1px #8990a5;
    top: -14px;
    left: 8px;
    background-color: #4381a9;
    padding: 8px;
    line-height: 14px;
    color: #fff;
}

.el-form-item /deep/ .el-form-item__content * {
    text-align: center;
}

.is-fill {
    width: 100%;
}

/* .my-form1 {
  margin-top: 16px;
} */
</style>